import React, { useEffect, useState } from "react";
import {
    Grid,
    Typography,
    Button,
    Box,
    Paper,
    Fade,
    Slide,
    Container,
    useTheme,
    useMediaQuery
} from "@mui/material";
import {useNavigate, useParams} from "react-router-dom";
import {
    CheckCircle,
    Error,
    Home,
    Receipt,
    ArrowBack,
} from "@mui/icons-material";
import {ErrorToaast} from "../../utils/toast/Toast";
import {BillModel} from "../../Api/Models/bill";
import ConvertDateToFa from "../../utils/tools/DateToFa";



const PaySuccess = () => {

    const { id } = useParams();
    const [success] = useState(true);
    const [show, setShow] = useState(false);
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [paymentDetails, setPaymentDetails] = useState<any|null>(null);
    const billmodel = new BillModel();
    const loadBll=async ()=>{
        if (id)
        billmodel
            .GetById(parseInt(id))
            .then((r) => {
                const res=r.data.data
                setPaymentDetails(res)

            })
            .catch((e) => {
                ErrorToaast("خطا در برقراری ارتباط");
                navigate("/", { replace: true });
            });
    }
    useEffect(() => {
        loadBll()
        const timer = setTimeout(() => setShow(true), 100);
        return () => clearTimeout(timer);
    }, []);

    return (
        <Container maxWidth="md">
            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{ minHeight: "100vh", padding: isMobile ? "20px" : "40px" }}
            >
                <Slide direction="up" in={show} timeout={500}>
                    <Paper
                        elevation={6}
                        sx={{
                            width: "100%",
                            maxWidth: 600,
                            borderRadius: 4,
                            overflow: "hidden",
                            background: "linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%)",
                            position: "relative"
                        }}
                    >
                        <Box
                            sx={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                right: 0,
                                height: 8,
                                background: success
                                    ? "linear-gradient(90deg, #00b09b, #96c93d)"
                                    : "linear-gradient(90deg, #ff416c, #ff4b2b)"
                            }}
                        />

                        <Box sx={{ p: isMobile ? 3 : 5 }}>
                            <Fade in={show} timeout={800}>
                                <Box sx={{ textAlign: "center", mb: 4 }}>
                                    <Box
                                        sx={{
                                            width: 100,
                                            height: 100,
                                            mx: "auto",
                                            mb: 3,
                                            borderRadius: "50%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            // background: success
                                            //     ? "linear-gradient(135deg, #00b09b 0%, #96c93d 100%)"
                                            //     : "linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%)",
                                            boxShadow: `0 10px 30px ${success ? 'rgba(0,176,23,0.3)' : 'rgba(255, 65, 108, 0.3)'}`,
                                            animation: "pulse 2s infinite"
                                        }}
                                    >
                                        {success ? (
                                            <CheckCircle sx={{ fontSize: 60, color: "white" }} />
                                        ) : (
                                            <Error sx={{ fontSize: 60, color: "white" }} />
                                        )}
                                    </Box>

                                    <Typography
                                        variant="h4"
                                        gutterBottom
                                        sx={{
                                            fontWeight: 700,
                                            color: success ? "#2e7d32" : "#d32f2f",
                                            mb: 1
                                        }}
                                    >
                                        {success ? "پرداخت موفق" : "پرداخت ناموفق"}
                                    </Typography>

                                    <Typography
                                        variant="body1"
                                        sx={{
                                            color: theme.palette.text.secondary,
                                            fontSize: "1.1rem",
                                            mb: 3
                                        }}
                                    >
                                        {success
                                            ? "پرداخت شما با موفقیت انجام شد و تایید گردید"
                                            : "متاسفانه پرداخت شما تکمیل نشد. لطفا مجددا تلاش کنید"}
                                    </Typography>
                                </Box>
                            </Fade>

                            <Fade in={show} timeout={1000}>
                                <Paper
                                    elevation={2}
                                    sx={{
                                        p: 3,
                                        mb: 4,
                                        borderRadius: 3,
                                        background: "white",
                                        borderLeft: `4px solid ${success ? "#4caf50" : "#f44336"}`
                                    }}
                                >
                                    <Typography
                                        variant="h6"
                                        sx={{ mb: 3, display: "flex", alignItems: "center", gap: 1 }}
                                    >
                                        <Receipt color="primary" />
                                        جزئیات تراکنش
                                    </Typography>

                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <Typography variant="caption" color="textSecondary">
                                                شماره تراکنش
                                            </Typography>
                                            <Typography variant="body2" fontWeight="medium">
                                                {paymentDetails&&paymentDetails.billNumber}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="caption" color="textSecondary">
                                                مبلغ
                                            </Typography>
                                            <Typography variant="body2" fontWeight="medium">
                                                {paymentDetails&&paymentDetails.totalAmount}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="caption" color="textSecondary">
                                                تاریخ
                                            </Typography>
                                            <Typography variant="body2" fontWeight="medium">
                                                {paymentDetails&&ConvertDateToFa(paymentDetails.paidDate)}
                                            </Typography>
                                        </Grid>
                                        {/*<Grid item xs={12}>*/}
                                        {/*    <Typography variant="caption" color="textSecondary">*/}
                                        {/*        شماره پیگیری*/}
                                        {/*    </Typography>*/}
                                        {/*    <Typography variant="body2" fontWeight="medium">*/}
                                        {/*        {paymentDetails.reference}*/}
                                        {/*    </Typography>*/}
                                        {/*</Grid>*/}
                                    </Grid>
                                </Paper>
                            </Fade>
                            <Fade in={show} timeout={1400}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: isMobile ? "column" : "row",
                                        gap: 2,
                                        justifyContent: "center",
                                        mt: 4
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        size="large"
                                        startIcon={<Home />}
                                        onClick={() => navigate("/")}
                                        sx={{
                                            py: 1.5,
                                            color:'#fff',
                                            px: 4,
                                            borderRadius: 2,
                                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                            "&:hover": {
                                                transform: "translateY(-2px)",
                                                boxShadow: "0 6px 16px rgba(0, 0, 0, 0.15)"
                                            },
                                            transition: "all 0.3s ease"
                                        }}
                                    >
                                        بازگشت به صفحه اصلی
                                    </Button>

                                    <Button
                                        variant="outlined"
                                        size="large"
                                        startIcon={<ArrowBack />}
                                        onClick={() => navigate(-1)}
                                        sx={{
                                            py: 1.5,
                                            color:'blue',
                                            px: 4,
                                            borderRadius: 2,
                                            borderWidth: 2,
                                            "&:hover": {
                                                borderWidth: 2,
                                                transform: "translateY(-2px)"
                                            },
                                            transition: "all 0.3s ease"
                                        }}
                                    >
                                        بازگشت به صفحه قبل
                                    </Button>
                                </Box>
                            </Fade>
                        </Box>
                    </Paper>
                </Slide>

                {success && (
                    <Fade in={show} timeout={2000}>
                        <Typography
                            variant="caption"
                            sx={{
                                mt: 3,
                                color: theme.palette.text.secondary,
                                opacity: 0.8
                            }}
                        >
                            با تشکر از اعتماد شما
                        </Typography>
                    </Fade>
                )}
            </Grid>

            <style>
                {`
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }
          
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          
          body {
           min-height: 100vh;
            margin: 0;
          }
        `}
            </style>
        </Container>
    );
};

export default PaySuccess;